// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.price {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.price .title {
  text-align: center;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 0 !important;
}
.price .title h1 {
  font-size: 40px;
  font-weight: 600;
  position: relative;
  z-index: 1111;
}
.price .title p {
  color: var(--ion-color-medium);
  font-size: 16px;
  margin-top: 10px;
  position: relative;
  z-index: 1111;
}
.price .title p span {
  color: var(--ion-color-medium);
}
.price ion-list {
  height: 100%;
  padding-top: 16px;
  padding: 32px;
  border-bottom: 1px solid var(--ion-color-light);
}
.price ion-list ion-item {
  margin-bottom: 10px;
}
.price ion-list ion-label {
  font-size: 16px !important;
}
.price ion-list ion-note {
  font-size: 16px !important;
}

.data {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}
.data .title {
  height: 100%;
}
.data .title h1 {
  font-size: 45px;
}
.data .title p {
  font-size: 25px !important;
  margin-bottom: 16px;
}
.data .title p span {
  font-size: 25px !important;
}

.radio-container {
  margin: 0px -8px;
}

@media (max-width: 767px) {
  .data {
    padding-bottom: env(safe-area-inset-bottom) !important;
  }
  .price {
    padding: 32px;
  }
}
.title h1 {
  font-size: 50px;
}
.title h2 {
  font-size: 25px;
  font-weight: 400;
}
.title h2 span {
  font-size: 25px;
}
.title h3 {
  font-size: 20px;
  font-weight: 600;
}

ion-footer ion-toolbar {
  --min-height: 90px !important;
}
ion-footer ion-button {
  font-size: 19px !important;
  height: 60px !important;
  --border-radius: 8px;
}
ion-footer .radio-container {
  margin: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/discount-card/select-amount-board/select-amount-board.component.scss"],"names":[],"mappings":"AAAA;EACC,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AACD;AACC;EACC,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,2BAAA;AACF;AACE;EACC,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;AACH;AAEE;EACC,8BAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;AAAH;AAEG;EACC,8BAAA;AAAJ;AAKC;EACC,YAAA;EACA,iBAAA;EACA,aAAA;EACA,+CAAA;AAHF;AAKE;EACC,mBAAA;AAHH;AAME;EACC,0BAAA;AAJH;AAOE;EACC,0BAAA;AALH;;AAUA;EACC,aAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;AAPD;AASC;EACC,YAAA;AAPF;AASE;EACC,eAAA;AAPH;AAUE;EACC,0BAAA;EACA,mBAAA;AARH;AAUG;EACC,0BAAA;AARJ;;AAcA;EACC,gBAAA;AAXD;;AAcA;EACC;IACC,sDAAA;EAXA;EAcD;IACC,aAAA;EAZA;AACF;AAgBC;EACC,eAAA;AAdF;AAiBC;EACC,eAAA;EACA,gBAAA;AAfF;AAiBE;EACC,eAAA;AAfH;AAmBC;EACC,eAAA;EACA,gBAAA;AAjBF;;AAsBC;EACC,6BAAA;AAnBF;AAsBC;EACC,0BAAA;EACA,uBAAA;EACA,oBAAA;AApBF;AAuBC;EACC,oBAAA;AArBF","sourcesContent":[".price {\n\twidth: 100%;\n\theight: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tjustify-content: center;\n\n\t.title {\n\t\ttext-align: center;\n\t\tposition: relative;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tjustify-content: center;\n\t\tmargin-bottom: 0 !important;\n\n\t\th1 {\n\t\t\tfont-size: 40px;\n\t\t\tfont-weight: 600;\n\t\t\tposition: relative;\n\t\t\tz-index: 1111;\n\t\t}\n\n\t\tp {\n\t\t\tcolor: var(--ion-color-medium);\n\t\t\tfont-size: 16px;\n\t\t\tmargin-top: 10px;\n\t\t\tposition: relative;\n\t\t\tz-index: 1111;\n\n\t\t\tspan {\n\t\t\t\tcolor: var(--ion-color-medium);\n\t\t\t}\n\t\t}\n\t}\n\n\tion-list {\n\t\theight: 100%;\n\t\tpadding-top: 16px;\n\t\tpadding: 32px;\n\t\tborder-bottom: 1px solid var(--ion-color-light);\n\n\t\tion-item {\n\t\t\tmargin-bottom: 10px;\n\t\t}\n\n\t\tion-label {\n\t\t\tfont-size: 16px !important;\n\t\t}\n\n\t\tion-note {\n\t\t\tfont-size: 16px !important;\n\t\t}\n\t}\n}\n\n.data {\n\tdisplay: flex;\n\tflex-direction: column;\n\twidth: 100%;\n\theight: 100%;\n\n\t.title {\n\t\theight: 100%;\n\n\t\th1 {\n\t\t\tfont-size: 45px;\n\t\t}\n\n\t\tp {\n\t\t\tfont-size: 25px !important;\n\t\t\tmargin-bottom: 16px;\n\n\t\t\tspan {\n\t\t\t\tfont-size: 25px !important;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.radio-container {\n\tmargin: 0px -8px;\n}\n\n@media (max-width: 767px) {\n\t.data {\n\t\tpadding-bottom: env(safe-area-inset-bottom) !important;\n\t}\n\n\t.price {\n\t\tpadding: 32px;\n\t}\n}\n\n.title {\n\th1 {\n\t\tfont-size: 50px;\n\t}\n\n\th2 {\n\t\tfont-size: 25px;\n\t\tfont-weight: 400;\n\n\t\tspan {\n\t\t\tfont-size: 25px;\n\t\t}\n\t}\n\n\th3 {\n\t\tfont-size: 20px;\n\t\tfont-weight: 600;\n\t}\n}\n\nion-footer {\n\tion-toolbar {\n\t\t--min-height: 90px !important;\n\t}\n\n\tion-button {\n\t\tfont-size: 19px !important;\n\t\theight: 60px !important;\n\t\t--border-radius: 8px;\n\t}\n\n\t.radio-container {\n\t\tmargin: 0 !important;\n\t}\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
